/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const CheckmarkIcon = ({
  title = 'Checkmark',
  viewBox = '0 0 16 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillOpacity=".01" d="M0 1h16v16H0z"/>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4 6.156a.92.92 0 00-1.263-1.339l-.04.037-7.592 7.593-2.603-2.603a.92.92 0 00-1.262-.038l-.04.038a.92.92 0 00-.036 1.262l.037.04 3.904 3.904L14.4 6.156z"
    />
  </CreateIconComponent>
);

export default CheckmarkIcon;
